import { render } from "./Chats.vue?vue&type=template&id=254e700a&scoped=true"
import script from "./Chats.vue?vue&type=script&lang=js"
export * from "./Chats.vue?vue&type=script&lang=js"

import "./Chats.vue?vue&type=style&index=0&id=254e700a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-254e700a"]])

export default __exports__